// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
    // XNG-Changes
    extendedStyles?: CardListHeadingStyles;
}

// XNG-Changes: added styles
interface CardListHeadingStyles {
    container?: GridItemProps;
    innerContainer?: InjectableCss;
    title?: TypographyPresentationProps;
    viewAll?: LinkPresentationProps;
}
export const cardListHeadingStyles: CardListHeadingStyles = {};

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(cardListHeadingStyles, extendedStyles));
    // XNG-Changes: restructured heading
    return (
        // <GridItem width={12}>
        //     <GridContainer
        //         offsetCss={css`
        //             border-bottom: 1px solid ${getColor("common.border")};
        //             padding-top: 40px;
        //             &&& {
        //                 width: 100%;
        //             }
        //         `}
        //     >
        //         <GridItem width={8}>
        //             <Typography className="card-list-heading" variant="h2">
        //                 {heading}
        //             </Typography>
        //         </GridItem>
        //         {viewAllUrl && (
        //             <GridItem width={4}>
        //                 <Link
        //                     href={viewAllUrl}
        //                     icon={{ iconProps: { src: ChevronRight } }}
        //                     typographyProps={{ size: 15 }}
        //                     css={css`
        //                         margin-left: auto;
        //                         margin-top: 5px;
        //                     `}
        //                     className="view-all-link"
        //                     data-test-selector="cardListHeadingViewAllLink"
        //                 >
        //                     {translate("View All")}
        //                     <VisuallyHidden>
        //                         {translate("View All")} {heading}
        //                     </VisuallyHidden>
        //                 </Link>
        //             </GridItem>
        //         )}
        //     </GridContainer>
        // </GridItem>
        <GridItem {...styles.container}>
            <StyledWrapper {...styles.innerContainer}>
                <Typography {...styles.title}>{heading}</Typography>
                {viewAllUrl && (
                    <Link href={viewAllUrl} {...styles?.viewAll}>
                        {translate("View All")}
                    </Link>
                )}
            </StyledWrapper>
        </GridItem>
    );
};

export default CardListHeading;
